import React from 'react';
import Box from '@mui/material/Box';
import { tokens } from '../theme';

/**
 * Gerda lockup: low-poly wolf mark + text wordmark.
 *
 * variant: 'gradient' (default) paints the word with the accent gradient,
 * 'solid' renders it in ink for places where a gradient would be noisy.
 * Pass mark={false} for the wordmark on its own.
 */
export default function Logo({ size = 26, variant = 'gradient', mark = true, gap = '1.8px', sx = {}, ...other }) {
    const gradient = `linear-gradient(115deg, ${tokens.accentDark} 0%, ${tokens.accent} 45%, ${tokens.accentLight} 100%)`;

    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap,
                userSelect: 'none',
                lineHeight: 1,
                ...sx,
            }}
            {...other}
        >
            {mark ? (
                <Box
                    component="img"
                    src="/gerda-mark.png"
                    alt=""
                    sx={{ height: size * 1.32, width: 'auto', display: 'block', flexShrink: 0 }}
                />
            ) : null}
            <Box
                component="span"
                sx={{
                    display: 'inline-flex',
                    alignItems: 'baseline',
                    fontSize: size,
                    lineHeight: 1,
                    fontWeight: 700,
                    letterSpacing: '-0.035em',
                    ...(variant === 'gradient'
                        ? {
                              backgroundImage: gradient,
                              WebkitBackgroundClip: 'text',
                              backgroundClip: 'text',
                              color: 'transparent',
                              WebkitTextFillColor: 'transparent',
                          }
                        : { color: tokens.ink }),
                }}
            >
                Gerda
                <Box
                    component="span"
                    sx={{
                        width: size * 0.17,
                        height: size * 0.17,
                        ml: `${size * 0.09}px`,
                        borderRadius: '50%',
                        backgroundColor: tokens.accent,
                        // The dot keeps its own colour when the word is a gradient.
                        WebkitTextFillColor: 'initial',
                        alignSelf: 'flex-end',
                        mb: `${size * 0.07}px`,
                        flexShrink: 0,
                    }}
                />
            </Box>
        </Box>
    );
}
